{
  "NIF": "12345678A",
  "NIF_tipo_documento": "DNI",
  "fecha_cv": "2025-08-26",
  "datos_personales": {
    "nombre": "Ana",
    "apellidos": "Pérez López",
    "genero": "F",
    "fecha_nacimiento": "1990-05-14",
    "provincia_de_residencia": "Madrid",
    "telefono": "600123456",
    "email": "ana.perez@email.com",
    "direccion": "Calle Falsa 123",
    "codigo_postal": "28080",
    "ciudad": "Madrid",
    "discapacidad": [
      {
        "tipo": "Visual",
        "grado": "33%"
      }
    ]
  },
  "experiencia": [
    {
      "puesto": "Farmacóloga Senior",
      "empresa": "Farmacias Madrid S.A.",
      "ubicacion": "Madrid",
      "fecha_inicio": "2015-06-01",
      "fecha_fin": "2020-12-31",
      "detalles": ["Gestión de laboratorio farmacéutico", "Supervisión de equipo de 5 personas"],
      "validado": true
    },
    {
      "puesto": "Investigadora Clínica",
      "empresa": "Clínica San José",
      "ubicacion": "Madrid",
      "fecha_inicio": "2021-01-01",
      "fecha_fin": "2023-12-31",
      "detalles": ["Participación en ensayos clínicos", "Redacción de informes y publicaciones científicas"],
      "validado": false
    }
  ],
  "ocupacion": [
    {
      "meses": "108",
      "ubicaciones": ["Madrid", "Barcelona"],
      "sector": "Salud",
      "subsector": "Farmacia",
      "oficio": "Farmacóloga"
    }
  ],
  "formacion": [
    {
      "titulo": "Licenciatura en Farmacia",
      "institucion": "Universidad Complutense de Madrid",
      "fecha_inicio": "2008-09-01",
      "fecha_fin": "2013-06-30",
      "finalizada": true,
      "validado": false
    },
    {
      "titulo": "Máster en Investigación Clínica",
      "institucion": "Universidad Autónoma de Madrid",
      "fecha_inicio": "2014-09-01",
      "fecha_fin": "2015-06-30",
      "finalizada": true,
      "validado": true
    }
  ],
  "cursos_certificaciones": [
    {
      "titulo": "Curso de Farmacología Avanzada",
      "descripcion": "Profundización en investigación farmacéutica",
      "otra_informacion": "",
      "validado": true
    },
    {
      "titulo": "Certificación en Buenas Prácticas Clínicas",
      "descripcion": "Normas de calidad para investigación clínica",
      "otra_informacion": "",
      "validado": false
    }
  ],
  "competencias": {
    "tecnicas": [
      {
        "nombre": "Investigación farmacéutica",
        "nivel": "Avanzado"
      }
    ],
    "softskills": ["Trabajo en equipo", "Comunicación", "Gestión de proyectos"]
  },
  "posibles_puestos_de_trabajo": [
    {
      "puesto": "Directora de laboratorio farmacéutico",
      "justificacion": "Experiencia previa liderando equipos y proyectos en farmacología"
    }
  ],
  "idiomas": [
    {
      "idioma": "Español",
      "nivel": "Nativo",
      "certificacion": "",
      "validado": true
    },
    {
      "idioma": "Inglés",
      "nivel": "Avanzado",
      "certificacion": "TOEFL 110",
      "validado": false
    }
  ],
  "intereses": "Investigación farmacéutica, educación y divulgación científica",
  "preferencias": "Trabajo remoto parcial, horario flexible",
  "restricciones": "No disponibilidad para traslados frecuentes",
  "informacion_adicional": "Se valorará experiencia en gestión de proyectos internacionales",
  "informacion_deducida": [
    {
      "deduccion": "Alta experiencia en gestión de equipos y proyectos",
      "justificacion": "Más de 10 años en el sector farmacéutico liderando proyectos complejos"
    }
  ]
}
